import { render } from "./CompanyAlignmentScoreCell.vue?vue&type=template&id=80a52c3e"
import script from "./CompanyAlignmentScoreCell.vue?vue&type=script&lang=js"
export * from "./CompanyAlignmentScoreCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__